let calendlyScriptsEnqueued = false;

export const enqueueCalendlyScripts = () => {
    if (calendlyScriptsEnqueued) {
        return;
    }

    const scriptTag = document.createElement('script');
    const linkTag = document.createElement('link');

    scriptTag.src = 'https://assets.calendly.com/assets/external/widget.js';
    scriptTag.type = 'text/javascript';

    linkTag.rel = 'stylesheet';
    linkTag.href = 'https://assets.calendly.com/assets/external/widget.css';

    document.getElementsByTagName('body')[0].appendChild(scriptTag);
    document.getElementsByTagName('head')[0].appendChild(linkTag);

    calendlyScriptsEnqueued = true;
};
